<template>
  <div
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-card :bordered="true" title="日报信息">
        <a-form :form="form">
          <a-row :gutter="16">
            <a-col class="gutter-row" :md="12" :sm="36">
              <a-form-item
                label="项目"
              >
                <a-select
                  style="width: 70%"
                  showSearch
                  :disabled="showable"
                  placeholder="请选择"
                  v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                  :options="projectList"
                  optionFilterProp="children"
                  @select="mySelect"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="36">
              <a-form-item label="时间">
                <a-date-picker
                  :disabled="showable"
                  :disabled-date="disabledDate"
                  style="width: 70%"
                  v-decorator="['dailyDate', {rules: [{required: true, message: '请选择时间'}]}]"
                ></a-date-picker>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-card>
      <br>
      <daily-component
        :project-id="projectId"
        :childType="type"
        :columns="workerColumns"
        :childDataSource="dailyWorkSource"
        title="自有工人"
        modalRef="dailyWorkAdd"
        @changeFatherData="(data) => dailyWorkSource = data"
        @changeFatherDeleteList="(data) => delectWorkerList = data"
      ></daily-component>
      <br>
      <daily-component
        :childType="type"
        :columns="hireWorkerColumns"
        :childDataSource="dailyHireWorkSource"
        title="外雇工人"
        modalRef="dailyHireWorkAdd"
        @changeFatherData="(data) => dailyHireWorkSource = data"
        @changeFatherDeleteList="(data) => delectHireWorkerList = data"
      ></daily-component>
      <br>
      <daily-component
        :childType="type"
        :columns="outMachineColumns"
        :childDataSource="dailyOutMachineSource"
        :is-scroll="true"
        title="外雇机械"
        modalRef="dailyOutMachineAdd"
        @changeFatherData="(data) => dailyOutMachineSource = data"
        @changeFatherDeleteList="(data) => delectOutMachineList = data"
        @deleteMaterialTimeDetailList="(data) => deleteMaterialTimeDetailList = data"
      ></daily-component>
      <br>
      <daily-component
        :childType="type"
        :columns="treeColumns"
        :childDataSource="dailyTreeSource"
        title="进场苗木"
        modalRef="dailyTreeAdd"
        @changeFatherData="(data) => dailyTreeSource = data"
        @changeFatherDeleteList="(data) => delectTreeList = data"
      ></daily-component>
      <br>
      <daily-component
        :childType="type"
        :columns="materialColumns"
        :childDataSource="dailyMaterialSource"
        title="进场主材"
        subTitle="由采购部采购，工地各种主材以及无法(或实际不会再)周转使用的材料、物资"
        modalRef="dailyMaterialAdd"
        @changeFatherData="(data) => dailyMaterialSource = data"
        @changeFatherDeleteList="(data) => delectMaterialList = data"
      ></daily-component>
      <br>
      <daily-component
        :childType="type"
        :columns="assetColumns"
        :childDataSource="dailyAssetSource"
        title="进场固定资产"
        subTitle="由采购部采购，能在各工地周转使用多年的设备、工具等，如发电机、水准仪、打草机"
        modalRef="dailyAssetAdd"
        @changeFatherData="(data) => dailyAssetSource = data"
        @changeFatherDeleteList="(data) => delectAssetList = data"
      ></daily-component>
      <br>
      <daily-component
        :childType="type"
        :columns="otherCostColumns"
        :childDataSource="dailyOtherCostSource"
        title="现金支付"
        subTitle="由项目部支付，直接到财务部报销的费用，需录入每张单据的每项明细，越细越好"
        modalRef="dailyOtherCostAdd"
        @changeFatherData="(data) => dailyOtherCostSource = data"
        @changeFatherDeleteList="(data) => delectOtherCostList = data"
      ></daily-component>
      <br>
      <daily-curing-result
        :childType="type"
        title="完成养护情况"
        :dropDownWateringList="dropDownWateringList"
        :dropDownPruneList="dropDownPruneList"
        :dailyCuringResultSource="dailyCuringResultSource"
        @changeResultData="(data) => dailyCuringResultSource=data"
        ref="curing"
      />
      <br>
      <a-card :bordered="true">
        <span slot="title">
          {{ '备注' }}
          <span style="color: red;font-size: 13px">{{ '：(其他情况说明)' }}</span>
        </span>
        <a-form :form="form">
          <a-form-item
            label=""
          >
            <a-textarea
              :disabled="showable"
              style="width: 1600px"
              :rows="6"
              placeholder="请输入阶段描述"
              v-decorator="['otherInfo']"
            ></a-textarea>
          </a-form-item>
        </a-form>
      </a-card>
      <footer-tool-bar>
        <a-button
          @click="handleCancel">取消</a-button>
        &nbsp;&nbsp;
        <a-button
          @click="handleOk"
          v-show="!showable">保存</a-button>
        <a-button
          type="primary"
          icon="download"
          v-if="type === 'show' && dailyInfoState === '3'"
          @click="handleExportExcel">导出</a-button>
      &nbsp;  &nbsp;
        <span v-action="'dailyCuring:dailyCuringView:audit'" v-if="type === 'show' && dailyInfoState === '1'">
          <a-button
            @click="agree">通过</a-button>
        &nbsp;
          <a-button
            type="danger"
            @click="reject">驳回</a-button>
        &nbsp;
        </span>
        <span v-if="dailyInfoState === '0' && type === 'show'">
          <a-button
            type="primary"
            @click="checkInfo">提交审核</a-button>
        </span>
      </footer-tool-bar>
    </a-spin>
  </div>

</template>

<script>
import { dropProjectByType } from '@/api/project/ProjectInfo'
import { dropAttendGroupListByProjectId } from '@/api/common/AttendGroup'
import { dropSxWorkerTypeList } from '@/api/common/SxWorkerType'
import { dropDownByCode } from '@/api/sys/user'
import { dropDownByDict } from '@/api/sys/dict'
import { dailyById, saveDailyCuring, agreeDailyInfo, rejectDailyInfo, modifyDailyCuring, checkDailyInfo, exportExcel } from '@/api/daily/DailyInfo'
import FooterToolBar from '../../../../../components/FooterToolbar/FooterToolBar'
import dailyComponent from '../common/dailyComponent'
import dailyCuringResult from '../common/dailyCuringResult'
import moment from 'moment'
import pick from 'lodash.pick'
import { Ellipsis } from '@/components'
export default {
  name: 'DailyCuringAdd',
  components: {
    FooterToolBar,
    dailyComponent,
    dailyCuringResult,
    Ellipsis
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      queryParam: {
        infoId: undefined
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      showable: false,
      count: 0,
      autoCount: 100,
      attendGroupList: [],
      dropSxWorkerTypeList: [],
      projectList: [],
      purchaserList: [],
      dropDownWateringList: [],
      dropDownPruneList: [],
      treeData: [],
      tableData: [],
      dailyWorkSource: [],
      dailyHireWorkSource: [],
      dailyOutMachineSource: [],
      dailyTreeSource: [],
      dailyAssetSource: [],
      dailyMaterialSource: [],
      dailyOtherCostSource: [],
      dailyCuringResultSource: {},
      dailyCuringResult: {},
      delectWorkerList: [],
      delectHireWorkerList: [],
      delectOutMachineList: [],
      delectTreeList: [],
      delectAssetList: [],
      delectMaterialList: [],
      delectOtherCostList: [],
      deleteMaterialTimeDetailList: [],
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      wateringQuery: {
        type: 'Watering'
      },
      pruneQuery: {
        type: 'prune'
      },
      workerColumns: [
        {
          title: '考勤小组',
          width: '180px',
          dataIndex: 'groupId',
          customRender: record => {
            return (
              <div>
                {this.attendGroupList.map(item => {
                  if (item.value === record) {
                    return item.label
                  }
                })}
              </div>
            )
          }
        },
        {
          title: '工人类别',
          width: '180px',
          dataIndex: 'typeId',
          customRender: record => {
            return (
              <div>
                {this.dropSxWorkerTypeList.map(item => {
                  if (item.value === record) {
                    return item.label
                  }
                })}
              </div>
            )
          }
        },
        {
          title: '用工数量',
          width: '120px',
          dataIndex: 'number',
          customRender: (text, record) => {
            return (
              <div>
                {text + `*` + record.workHour}
              </div>
            )
          }
        },
        {
          title: '合计工时(h)',
          width: '120px',
          dataIndex: 'totalHour',
          customRender: (text, record) => {
            return (
              <div>
                {Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '工作内容及工作量',
          dataIndex: 'content',
          customRender: (text) => {
            return (
              <ellipsis length={36} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={36} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '120px',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      hireWorkerColumns: [
        {
          title: '队伍名称',
          width: '180px',
          dataIndex: 'teamName'
        },
        {
          title: '费用内容及完成工作情况',
          dataIndex: 'content',
          width: '400px',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={36} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '费用金额',
          width: '120px',
          dataIndex: 'totalPrice',
          customRender: (text, record) => {
            return (
              <div>
                {Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '备注',
          width: '400px',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={36} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '120px',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      outMachineColumns: [
        {
          title: '客户名称',
          width: '150px',
          dataIndex: 'customerName',
          customRender: (text) => {
            return (
              <ellipsis length={14} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '机械类别',
          width: '120px',
          dataIndex: 'type',
          customRender: (text) => {
            return (
              <ellipsis length={14} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '单号',
          width: '120px',
          dataIndex: 'orderNumber',
          customRender: (text) => {
            return (
              text === null ? ' '
                : <ellipsis length={14} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '工作时间明细',
          width: '150px',
          customRender: (text, record) => {
            return (
              <div>
                { String(record.chargeMode) === '0' ? '-'
                  : record.dateList.length > 1
                    ? <a-tooltip placement="top">
                      <template slot="title" >
                        <span style="whiteSpace: pre-wrap">{record.dateList.map(da => { return da.startTime + ' - ' + da.endTime + '\n' })}</span>
                      </template>多段时间段</a-tooltip>
                    : record.dateList.length === 0 ? ' - '
                      : <a-tooltip placement="top">
                        <template slot="title" >
                          <span style="whiteSpace: pre-wrap">{record.dateList.map(da => { return da.startTime + ' - ' + da.endTime })}</span>
                        </template>一段时间</a-tooltip>}
              </div>
            )
          }
        },
        {
          title: '总工作时间',
          width: '150px',
          dataIndex: 'totalHour',
          customRender: (text, record) => {
            return (
              <div>
                { String(record.chargeMode) === '0' ? '-' : parseInt(String(text / 60.0)).toFixed(0) + '小时' + parseInt(String(text % 60)).toFixed(0) + '分钟(' +
                  (text / 60.00).toFixed(2) +
                  'h)'}
              </div>
            )
          }
        },
        {
          title: '单价',
          width: '62px',
          align: 'center',
          dataIndex: 'price',
          customRender: (text, record) => {
            return (
              <div>
                {String(record.chargeMode) === '0' ? '-' : text || ' - '}
              </div>
            )
          }
        },
        {
          title: '项',
          align: 'center',
          width: '100px',
          dataIndex: 'item',
          customRender: (text, record) => {
            return (
              <ellipsis length={14} tooltip>{String(record.chargeMode) === '0' ? text || ' - ' : ' - '}</ellipsis>
            )
          }
        },
        {
          title: '总金额',
          width: '70px',
          align: 'center',
          dataIndex: 'amount',
          customRender: (text) => {
            return (
              <div>
                {text || ' - '}
              </div>
            )
          }
        },
        {
          title: '工作内容及工作量',
          align: 'center',
          width: '200px',
          dataIndex: 'content',
          customRender: (text) => {
            return (
              <ellipsis length={14} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '备注',
          width: '100px',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={14} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '120px',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      treeColumns: [
        {
          title: '苗木名称',
          width: '150px',
          dataIndex: 'name'
        },
        {
          title: '规格',
          width: '120px',
          dataIndex: 'format'
        },
        {
          title: '数量',
          width: '100px',
          dataIndex: 'number',
          customRender: (text, record) => {
            return (
              <div>
                {text + record.unit}
              </div>
            )
          }
        },
        {
          title: '单号',
          width: '100px',
          dataIndex: 'orderNumber'
        },
        /*        {
          title: '运费',
          width: '100px',
          dataIndex: 'freight'
        }, */
        {
          title: '预付款',
          width: '100px',
          dataIndex: 'advancePay'
        },
        {
          title: '备注(供货商及其他信息)',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={26} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '采购人',
          width: '100px',
          dataIndex: 'purchaserId',
          customRender: record => {
            return (
              <div>
                {this.purchaserList.map(item => {
                  if (item.value === record) {
                    return item.label
                  }
                })}
              </div>
            )
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '120px',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      materialColumns: [
        {
          title: '主材名称',
          width: '150px',
          dataIndex: 'name'
        },
        {
          title: '规格',
          width: '120px',
          dataIndex: 'format'
        },
        {
          title: '数量',
          width: '100px',
          dataIndex: 'number',
          customRender: (text, record) => {
            return (
              <div>
                {text + record.unit}
              </div>
            )
          }
        },
        {
          title: '单号',
          width: '100px',
          dataIndex: 'orderNumber'
        },
        /*        {
          title: '运费',
          width: '100px',
          dataIndex: 'freight'
        }, */
        {
          title: '预付款',
          width: '100px',
          dataIndex: 'advancePay'
        },
        {
          title: '备注(供货商及其他信息)',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={26} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '采购人',
          dataIndex: 'purchaserId',
          width: '100px',
          customRender: record => {
            return (
              <div>
                {this.purchaserList.map(item => {
                  if (item.value === record) {
                    return item.label
                  }
                })}
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '120px',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      assetColumns: [
        {
          title: '固定资产名称',
          width: '200px',
          dataIndex: 'name'
        },
        {
          title: '规格',
          width: '120px',
          dataIndex: 'format'
        },
        {
          title: '数量',
          width: '100px',
          dataIndex: 'number',
          customRender: (text, record) => {
            return (
              <div>
                {text + record.unit}
              </div>
            )
          }
        },
        {
          title: '单号',
          width: '100px',
          dataIndex: 'orderNumber'
        },
        {
          title: '预付款',
          width: '100px',
          dataIndex: 'advancePay'
        },
        {
          title: '备注(供货商及其他信息)',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={30} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '采购人',
          width: '100px',
          dataIndex: 'purchaserId',
          customRender: record => {
            return (
              <div>
                {this.purchaserList.map(item => {
                  if (item.value === record) {
                    return item.label
                  }
                })}
              </div>
            )
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '120px',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      otherCostColumns: [
        {
          title: '费用名称',
          width: '200px',
          dataIndex: 'coustName'
        },
        {
          title: '数量',
          width: '120px',
          dataIndex: 'quantity',
          customRender: (text, record) => {
            return (
              <div>
                {text + record.unit}
              </div>
            )
          }
        },
        {
          title: '单价',
          width: '120px',
          dataIndex: 'price'
        },
        {
          title: '总金额',
          width: '120px',
          dataIndex: 'amount'
        },
        {
          title: '备注(用途等各种费用细节)',
          dataIndex: 'remark',
          customRender: (text) => {
            return (
              <div>
                {text === null ? ' '
                  : <ellipsis length={26} tooltip>{text}</ellipsis>
                }
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '120px',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      type: 'add',
      dailyInfoId: '',
      dailyInfoState: '',
      projectId: ''
    }
  },
  methods: {
    // 获取用户信息
    edit (num, type) {
      this.visible = true
      dropProjectByType('curing').then(res => {
        this.projectList = res.data
      })
      // dropAttendGroupList().then(res => {
      //   this.attendGroupList = res.data
      // })
      dropSxWorkerTypeList().then(res => {
        this.dropSxWorkerTypeList = res.data
      })
      dropDownByCode(this.purchaserQuery).then(res => {
        this.purchaserList = res.data
      })
      dropDownByDict(this.wateringQuery).then(res => {
        this.dropDownWateringList = res.data
      })
      dropDownByDict(this.pruneQuery).then(res => {
        this.dropDownPruneList = res.data
      })
      this.queryParam.infoId = num
      if (type && type === 'add') {
        this.addable = true
        this.type = type
      }
      if (type === 'edit') {
        this.editable = true
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      const { form: { resetFields, setFieldsValue } } = this
      if (['edit', 'show'].includes(type)) {
        if (['edit', 'show'].includes(type)) {
          this.confirmLoading = true
          const id = num
          dailyById(id).then(res => {
            this.confirmLoading = false
            const record = res.data.data.dailyInfo
            this.dailyInfoState = record.state
            this.dailyWorkSource = res.data.data.dailyWorker
            this.dailyHireWorkSource = res.data.data.dailyHireWorker
            this.dailyOutMachineSource = res.data.data.dailyOutMachine
            this.dailyTreeSource = res.data.data.dailyTree
            this.dailyMaterialSource = res.data.data.dailyMaterial
            this.dailyAssetSource = res.data.data.dailyAsset
            this.dailyOtherCostSource = res.data.data.dailyOtherCost
            this.dailyCuringResultSource = res.data.data.dailyCuringResult
            const pickFiled = ['id', 'projectId', 'otherInfo', 'dailyDate']
            this.projectId = record.projectId
            record.dailyDate = moment(record.dailyDate)
            this.$nextTick(() => {
              setFieldsValue(pick(record, pickFiled))
            })
          })
        } else {
          resetFields()
        }
      } else if (['add'].includes(type)) {
        resetFields()
        this.confirmLoading = false
      } else {
        resetFields()
      }
    },
    // 限制选择的日期
    disabledDate (current) {
      return current && current > moment().endOf('day')
    },
    // 结束保存用户信息
    handleOk () {
      const { form: { resetFields } } = this
      this.form.validateFields(async (err, values) => {
        this.$refs.curing.form.validateFields((err, values) => {
          this.dailyCuringResult = values
        })
        if (!err) {
          if (values.dailyDate != null) {
            values.dailyDate = moment(values.dailyDate).format('YYYY-MM-DD')
          }
          values.id = this.dailyInfoId
          const dailyInfo = values
          dailyInfo.dailyType = 'curing'
          dailyInfo.state = this.dailyInfoState
          const dailyWorker = this.dailyWorkSource
          const dailyHireWorker = this.dailyHireWorkSource
          const dailyOutMachine = this.dailyOutMachineSource
          const dailyTree = this.dailyTreeSource
          const dailyMaterial = this.dailyMaterialSource
          const dailyAsset = this.dailyAssetSource
          const dailyOtherCost = this.dailyOtherCostSource
          const dailyCureCreat = {}
          dailyCureCreat.dailyInfo = dailyInfo
          dailyCureCreat.dailyWorker = dailyWorker
          dailyCureCreat.dailyHireWorker = dailyHireWorker
          dailyCureCreat.dailyOutMachine = dailyOutMachine
          dailyCureCreat.dailyTree = dailyTree
          dailyCureCreat.dailyMaterial = dailyMaterial
          dailyCureCreat.dailyAsset = dailyAsset
          dailyCureCreat.dailyOtherCost = dailyOtherCost
          dailyCureCreat.dailyCuringResult = this.dailyCuringResult
          dailyCureCreat.delectWorkerList = this.delectWorkerList
          dailyCureCreat.delectHireWorkerList = this.delectHireWorkerList
          dailyCureCreat.delectOutMachineList = this.delectOutMachineList
          dailyCureCreat.delectTreeList = this.delectTreeList
          dailyCureCreat.delectMaterialList = this.delectMaterialList
          dailyCureCreat.delectAssetList = this.delectAssetList
          dailyCureCreat.delectOtherCostList = this.delectOtherCostList
          dailyCureCreat.deleteMaterialTimeDetailList = this.deleteMaterialTimeDetailList
          this.confirmLoading = true
          // 新增提交
          if (this.type === 'add') {
            await saveDailyCuring(dailyCureCreat).then(() => {
              this.$message.success('保存成功')
              // 成功提交之后，清空数据
              resetFields()
              this.clearData()
            }
            ).catch(err => {
              this.$message.error(err.msg)
            })
          }
          // 修改提交
          if (this.type === 'edit') {
            await modifyDailyCuring(dailyCureCreat).then(() => {
              this.$message.success('修改成功')
              // 修改成功之后重新获取数据
              this.edit(this.dailyInfoId, this.type)
              this.$router.push({ name: 'dailyCuringView' })
            }
            ).catch(err => {
              this.$message.error(err.msg)
            })
          }
          setTimeout(() => {
            this.confirmLoading = false
            // this.dailyWorkSource = []
            // this.dailyHireWorkSource = []
            // this.dailyOutMachineSource = []
            // this.dailyTreeSource = []
            // this.dailyMaterialSource = []
            // this.dailyAssetSource = []
            // this.dailyOtherCostSource = []
            // this.dailyCuringResultSource = {}
            // this.dailyCuringResult = {}
            // this.$emit('ok')
            // this.visible = false
          }, 1500)
        }
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleCancel () {
      this.$router.push({ name: 'dailyCuringView' })
    },
    changeFatherData (data) {
      this.dailyWorkSource = data
    },
    // 审核状态，0：未提交，1：审核中，2已驳回，3通过
    checkInfo () {
      const dailyInfoId = this.dailyInfoId
      checkDailyInfo(dailyInfoId).then(res => {
        this.edit(this.dailyInfoId, this.type)
        // this.$router.push({ name: 'dailyCuringView' })
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },

    agree () {
      const dailyInfoId = this.dailyInfoId
      agreeDailyInfo(dailyInfoId).then(res => {
        this.edit(this.dailyInfoId, this.type)
        // this.$router.push({ name: 'dailyCuringView' })
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    reject () {
      const dailyInfoId = this.dailyInfoId
      rejectDailyInfo(dailyInfoId).then(res => {
        this.edit(this.dailyInfoId, this.type)
        // this.$router.push({ name: 'dailyCuringView' })
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 工程选择框，选中时触发
    mySelect (e) {
      this.projectId = e
    },
    // 导出
    handleExportExcel () {
      exportExcel(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        // 处理导出日报的标题
        let pId = this.form.getFieldValue('projectId')
        this.projectList.forEach(da => {
          if (da.value === pId) {
            pId = da.label // 取出日报项目名称
          }
        })
        const date = moment(this.form.getFieldValue(['dailyDate'])).format('YYYY-MM-DD') || ''
        link.download = pId + date + '养护日报.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    },
    // 清空数据
    clearData () {
      this.type = 'add'
      this.showable = false
      this.dailyWorkSource = []
      this.dailyHireWorkSource = []
      this.dailyOutMachineSource = []
      this.dailyTreeSource = []
      this.dailyAssetSource = []
      this.dailyMaterialSource = []
      this.dailyOtherCostSource = []
      this.dailyCuringResultSource = {}
      this.dailyCuringResult = {}
      this.delectWorkerList = []
      this.delectHireWorkerList = []
      this.delectOutMachineList = []
      this.delectTreeList = []
      this.delectAssetList = []
      this.delectMaterialList = []
      this.delectOtherCostList = []
      this.deleteMaterialTimeDetailList = []
    }
  },
  watch: {
    projectId (val) {
      dropAttendGroupListByProjectId(val).then(res => {
        this.attendGroupList = res.data
      })
    }
  },
  activated () {
    this.clearData()
    this.dailyInfoId = this.$route.query.id
    this.type = this.$route.query.type
    this.dailyInfoState = this.$route.query.state
    this.edit(this.dailyInfoId, this.type)
  }
}
</script>

<style scoped>

</style>
